import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties } from 'react';
import { Cell as ReactTableCell, Row } from 'react-table';

import { Cell } from '../Cell';
import { Tr, Wrapper } from './rowStyle';

interface IProps {
  row: Row<any>;
  borderBottom?: boolean;
  borderRight?: boolean;
  tableBodyStyle?: CSSProperties;
  fullWidth?: boolean;
  isEven?: boolean;
  isOdd?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRowClick?: (row: Row<any>) => void;
  isDeleted?: boolean;
  hasRowReordering?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedReorderingRow?: Row<any>;
  isStaticRow?: boolean;
}

const RowView = ({
  row,
  borderBottom,
  borderRight,
  tableBodyStyle,
  fullWidth,
  isEven,
  isOdd,
  onRowClick,
  isDeleted = false,
  hasRowReordering,
  selectedReorderingRow,
  isStaticRow = false,
}: IProps) => {
  const { attributes, listeners, transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id,
  });

  const isEmptyRow = hasRowReordering && isDragging;

  const rowReorderingCellProps = hasRowReordering
    ? {
        attributes,
        listeners,
        isGrabbing: isStaticRow,
      }
    : {};

  const selectedRowHeight =
    hasRowReordering && document.getElementById(selectedReorderingRow?.original?.id)?.clientHeight;

  const content = (
    <Wrapper id={row?.original?.id}>
      {row.cells.map((cell: ReactTableCell, index: number) => (
        <Cell
          key={index}
          {...{
            row,
            cell,
            borderRight,
            tableBodyStyle,
            ...rowReorderingCellProps,
          }}
        />
      ))}
    </Wrapper>
  );

  return (
    <Tr
      ref={hasRowReordering ? setNodeRef : null}
      transform={hasRowReordering ? CSS.Transform.toString(transform) : null}
      transition={hasRowReordering ? transition : null}
      {...row.getRowProps()}
      isEven={isEven}
      isOdd={isOdd}
      isRowSelected={row.isSelected}
      borderBottom={borderBottom}
      fullWidth={fullWidth}
      onClick={() => typeof onRowClick === 'function' && onRowClick(row.original)}
      isDeleted={isDeleted}
      isEmpty={isEmptyRow}
      rowHeight={selectedRowHeight}
      isStaticRow={isStaticRow}
    >
      {!isEmptyRow && content}
    </Tr>
  );
};

export default RowView;
